<template>
  <div class="wrapper">
      <div class="left">
        <img src="../assets/title_logo.png" alt="">
      </div>
      <div class="right">
        <span :class="[act_==item.type?'active':'']" @click='herfRout(item.type)' v-for="(item,index) in list" :key="index"> {{item.name}}
            <transition name="slide-fade">
              <span v-if="act_==item.type"></span>
            </transition> 
        </span>
        <!-- <span>{{act_}}</span> -->
      </div>
  </div>
</template>

<script>
import {routelus} from '../utils'
import { log } from 'util';
export default {
  name:'headers',
  components: {
    // routelus
  },
  props: {},
  data() {
    return {
      list:[
        {'name':'首页','type':0},
        {'name':'关于我们','type':1},
        // {'name':'音乐上传','type':2}
      ],
    }
  },
  watch: {
    act_(a,b){
      routelus(a);
    }
  },
  computed: {
    act_(){
      return this.$store.state.user.active
    }
  },
  methods: {
    herfRout(e){
    //   if(e == 2){
    //     if(location.href.indexOf('http://127.0.0.1:8080')<0){
    //       location.href='http://127.0.0.1:8080';
    //     }
    //   }
      this.$store.commit("setActive", e);
      // routelus(e);
    }
  },
  created() {
    routelus(this.act_);
  },
  mounted: () => {}
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.wrapper{
    width: 100%;
    height: 5.365vw;
    padding: 0 10vw;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
        cursor: pointer;
        img{
            width: 9.5vw;
            height: auto;
        }
    }
    .right{
        height: 100%;
        text-align: right;
        >span{
            display: inline-block;
            margin-left: 2.6vw;
            width: 7.82vw;
            height: 100%;
            text-align: center;
            color: #000000;
            position: relative;
            font: bold 1.1vw/5.365vw PingFangSC-Regular, PingFang SC;
            cursor: pointer;
        }
        >span>span{
            position: absolute;
            width: 1.04vw;
            height: 4px;
            bottom: 0.78vw;
            left: 50%;
            margin-left: -0.52vw;
            z-index: 1;
            background-image: url('../assets/active_img.png');
            background-size: 100% 100%;
        }
        .active{
            // color: #9013FE;
        }
    .active>span{
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/components/headers.vue